import { z as e } from "zod";
const n = e.object({
  errorId: e.uuid(),
  timestamp: e.string()
}), o = n.extend({
  entityName: e.string(),
  fields: e.record(e.string(), e.unknown())
}), r = n.extend({
  entityName: e.string(),
  fields: e.record(e.string(), e.unknown()).optional(),
  uniqueField: e.string(),
  uniqueValue: e.unknown()
}), s = n.extend({
  entityName: e.string(),
  id: e.unknown(),
  usedBy: e.object({
    entityName: e.string(),
    ids: e.array(e.unknown()).optional()
  })
}), c = n.extend({
  entityName: e.string(),
  id: e.unknown(),
  fieldName: e.string()
}), d = n.extend({
  entityName: e.string(),
  fields: e.record(e.string(), e.unknown()),
  mismatch: e.record(
    e.string(),
    e.object({
      expected: e.unknown(),
      actual: e.unknown()
    })
  )
}), m = n.extend({
  issues: e.array(e.unknown())
}), t = e.enum(["invalid_credentials", "captcha_failed", "rate_limited"]), a = e.enum(["invisible", "visible", "blocked"]), u = n.extend({
  reason: t,
  challengeMode: a,
  retryAfterSec: e.number().nonnegative()
});
export {
  r as AlreadyExistsDataSchema,
  u as AuthRejectedDataSchema,
  t as AuthRejectionReasonSchema,
  a as CaptchaChallengeModeSchema,
  o as EntityNotFoundDataSchema,
  n as ErrorMetaSchema,
  d as ExpectationFailedDataSchema,
  c as FieldCannotBeUpdatedDataSchema,
  s as InUseDataSchema,
  m as ValidationErrorDataSchema
};
//# sourceMappingURL=schemas.js.map
